/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName";

let FormAnswersDetails = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/modules/coach/Resources/Forms/FormAnswersDetails.vue')

export default (rootComponent, masterRouteName, backRouteName) => {
	let answersRouteName = masterRouteName + "Answers"
	let answersMainRouteName = masterRouteName + "Main"
	// console.log("formQuestionsAnswersRoutesFn: answersRouteName = ", answersRouteName, ", answersMainRouteName = ", answersMainRouteName)
	return {
		children:[
			{
				path: '',
				component: rootComponent,
				name: masterRouteName,
				redirect: redirectByName(answersMainRouteName, {formTypeTab: 'questions'}),
				meta: {
					backRouteName
				},
				props: mergeProps,
				children:[
					{
						path: ':formTypeTab',
						name: answersMainRouteName,
						// components: {
						// 	answers: FormAnswersList
						// },
						meta:{
							answersRouteName
						},
						props: mergeProps,
					},
				]
			},

			{
				path: 'answers/:answerId/details',
				component: FormAnswersDetails,
				name: answersRouteName,
				props: mergeProps,

				meta:{
					masterRouteName: answersMainRouteName,
				},
			},
		],
	}

}
